module.exports = __webpack_public_path__ + "static/media/textVitality.ae5a4c4d.svg";